import * as React from 'react';
import { IInviteItem } from 'types/employee-registration';
import { phoneNumberAddHypen } from 'constants/utils';
import { regExp_phone } from 'constants/regExp';
import Button from 'common/button/button';
import TextInput from 'common/text-input/text-input';
import './add-invitation-list.scss';

interface Props {
  onClose: () => void;
  onSubmit: (empName: string, empPhone: string) => void;
}

const AddInvitationList: React.FC<Props> = ({ onClose, onSubmit }) => {
  const [error, setError] = React.useState<{ name: boolean; phone: boolean }>({
    name: false,
    phone: false,
  });
  const [inviteForm, setInviteForm] = React.useState<IInviteItem>({
    name: '',
    phone: '',
  });

  const onClick = () => {
    onClose();
  };

  const handleInviteForm = (event: any) => {
    const { name, value } = event.target;
    setInviteForm((values: any) => ({ ...values, [name]: name === 'phone' ? phoneNumberAddHypen(value) : value }));
  };

  const validCheck = () => {
    let valid = true;
    if (inviteForm.name === '') {
      valid = false;
      setError((values: any) => ({ ...values, name: true }));
    } else {
      setError((values: any) => ({ ...values, name: false }));
    }
    if (inviteForm.phone.length !== 13) {
      valid = false;
      setError((values: any) => ({ ...values, phone: true }));
    } else {
      if (!regExp_phone.test(inviteForm.phone)) {
        valid = false;
        setError((values: any) => ({ ...values, phone: true }));
      } else {
        setError((values: any) => ({ ...values, phone: false }));
      }
    }
    return valid;
  };

  const onSubmitInvitation = () => {
    if (validCheck()) {
      setInviteForm({ name: '', phone: '' });
      onSubmit(inviteForm.name, inviteForm.phone);
    }
  };

  return (
    <>
      <div className="add-invitation-list-modal">
        <div className="add-invitation-list-modal-content">
          <div className="add-invitation-list-modal-content__body">
            <div className="add-invitation-list-modal-content__input">
              <TextInput
                value={inviteForm.name}
                inputData={handleInviteForm}
                label="이름*"
                placeholder="이름 입력"
                inputName="name"
                maxLength={6}
                errorMessage={error.name ? '이름을 입력해 주세요' : ''}
              />
            </div>
            <div className="add-invitation-list-modal-content__input">
              <TextInput
                value={inviteForm.phone}
                inputData={handleInviteForm}
                label="핸드폰번호*"
                placeholder="휴대폰번호 입력"
                inputName="phone"
                maxLength={13}
                errorMessage={error.phone ? '올바른 휴대폰번호를 입력해 주세요' : ''}
              />
            </div>
            <div className="add-invitation-list-modal-content__buttons">
              <div className="add-invitation-list-modal-content__buttons__cancel">
                <Button label="취소" type="type4" action={onClick} height={56} />
              </div>
              <div className="add-invitation-list-modal-content__buttons__submit">
                <Button label="추가" type="type2" action={onSubmitInvitation} height={56} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddInvitationList;
